'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    var openedItems = [];

    function closeAll() {
        for (var i = 0; i < openedItems.length; i++) {
            $(openedItems[i]).removeClass('active');
        }
        openedItems = [];
    }

    // just fur category
    function setPosition() {
        if ($('.cat__triggers').length === 0) return;
        var top = $('.cat__triggers').offset().top - $('.header').height() - 30;

        $('.category__aside').css({ top: top });
    }

    $('[data-show-trigger]', this).click(function (e) {

        e.preventDefault();
        var $this = $(this);
        var contentClass = '.' + $this.attr('data-show');
        var $content = $(document).find(contentClass);

        if ($content.hasClass('active')) {
            $content.removeClass('active');
        } else {
            // close previous items
            closeAll();

            openedItems.push(contentClass);
            setPosition();
            $content.addClass('active');
        }
    });

    $('[data-show-close]', this).click(function (e) {
        e.preventDefault();

        closeAll();
    });

    // show more text
    $('.show-more-text', this).on('click', function (e) {
        e.preventDefault();

        var $wrap = $(this).closest('.show-more-text__wrap');

        $('.text-long', $wrap).removeClass('hidden');
        $('.text-short', $wrap).addClass('hidden');
        $(this).hide();

        if ($(this).closest('#hpTalkAbout').length > 0) {
            $('#hpTalkAbout .slick-list').css('height', 'auto');
        }
    });

    var floatingFooter = document.querySelector('.mobile-floating-footer');

    if (floatingFooter && window.getComputedStyle(floatingFooter).display !== 'none') {
        window.setTimeout(function () {
            return setMobileIconsLayout();
        }, 900);
        window.setTimeout(function () {
            return setMobileIconsLayout();
        }, 3000);
    }

    function setMobileIconsLayout() {
        var bottomValue = floatingFooter.getBoundingClientRect().height + 5;
        setBottomMobile('#btn-contact-form', bottomValue);
        setBottomMobile('#CookiebotWidget', bottomValue);
    }
    function setBottomMobile(selector, bottomValue) {
        var element = document.querySelector(selector);
        if (!element) return;

        element.style.bottom = bottomValue + 'px';
    }
};

; // for open and hide category filter in responsive
// this function can be global
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/showHideContent.js
// module id = 1083
// module chunks = 0